import { FC } from "react";
import { AdminToolsView } from "../../../../../modules/admin/views/admin-tools-view/admin-tools-view";

export const AdminToolsRoute: FC = () => {
    return (
        <AdminToolsView />
    )
}